import { render, staticRenderFns } from "./device-item-view.vue?vue&type=template&id=3062536b&scoped=true&"
import script from "./device-item-view.vue?vue&type=script&lang=js&"
export * from "./device-item-view.vue?vue&type=script&lang=js&"
import style0 from "./device-item-view.vue?vue&type=style&index=0&id=3062536b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062536b",
  null
  
)

export default component.exports